import {inject, injectable} from "inversify";
import {TransferDeciderInterface} from "@/modules/ai/interfaces";
import {Player, Team} from "@/modules/team/entity";
import chance from "@/modules/base/services/chance";
import {EventEmitter} from "@/modules/base/events";
import {PositionEnum} from "@/modules/base/enums";

@injectable()
export default class RandomTransferDecider implements TransferDeciderInterface {
  constructor(
    @inject(EventEmitter) protected em: EventEmitter,
  ) {}

  async getMinSkill(team: Team): Promise<number> {
    return 1;
  }

  async getMaxSkill(team: Team): Promise<number> {
    return Math.ceil(collect(team.players).avg('skill'));
  }

  async getPosition(team: Team): Promise<PositionEnum> {
    return chance.randomEnum(PositionEnum);
  }

  async getTransferTarget(team: Team): Promise<Player | null> {
    const position = await this.getPosition(team);

    return await Player
      .createQueryBuilder('player')
      .innerJoinAndSelect('player.team', 'team')
      .where('player.endsCareer = false AND player.careerEndedAt IS NULL and player.transferred = false')
      .andWhere('team.id != :teamId', {teamId: team.id})
      .andWhere('player.position = :playerPosition', {playerPosition: position})
      .andWhere(
        'player.skill >= :playerSkillFrom AND player.skill >= :playerSkillTo',
        {
          playerSkillFrom: await this.getMinSkill(team),
          playerSkillTo: await this.getMaxSkill(team),
        }
      )
      .orderBy('RANDOM()')
      .getOne();
  }
}
